var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bgColor)?_c('div',{directives:[{name:"background-color",rawName:"v-background-color",value:(_vm.bgColor),expression:"bgColor"}],class:{xl:_vm.isXL},attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keep)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keep)?_c('router-view'):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b00527","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 446
// module chunks = 4